import React, { useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { RatingDialog } from '../rating-dialog';
import { NoResults } from '../no-results';
import { ExtensionListPageThumbnails } from '../extensions-list-page-thumbnails';
import { getExtensionsList, addAwareness, marketplaceClosed, marketplaceExtensionViewed, marketplaceExtensionVoted, marketplaceExtensionClosed, } from '../../actions';
import { selectExtensionsList } from '../../selectors';
import { useHistory } from '../../../../components/navigation';
import { selectInstitution, selectUser, } from '../../../../store/features/system';
import { sortByTitle, filterAvailableExtensions, filterInstalledExtensions } from '../../utils';
import { nativeExtensionsList } from '../../constants';
import './extension-list-page.scss';
export const ExtensionListPage = () => {
    const user = useSelector(selectUser);
    const institution = useSelector(selectInstitution);
    const dispatch = useDispatch();
    const extensions = useSelector(selectExtensionsList);
    const [isFetching, setIsFetching] = useState(true);
    const [selectedExt, setSelectedExt] = useState();
    const history = useHistory();
    const marketplaceClosedTrack = useCallback((e) => {
        e.preventDefault();
        dispatch(marketplaceClosed());
    }, [dispatch]);
    const handleExtensionClick = useCallback((ext) => {
        dispatch(marketplaceExtensionViewed(ext));
        if (ext.isFake) {
            if (ext.isNew) {
                dispatch(addAwareness(String(ext.id)));
                dispatch(getExtensionsList());
            }
            setSelectedExt(ext);
        }
        else {
            history.push(`/account/extension/${ext.id}`);
        }
    }, [dispatch, history]);
    const handleSubmitRating = useCallback((rating) => {
        dispatch(marketplaceExtensionVoted(selectedExt.id, rating));
    }, [selectedExt, dispatch]);
    const handleDismissRating = useCallback(() => {
        dispatch(marketplaceExtensionClosed(selectedExt));
        setSelectedExt(undefined);
    }, [selectedExt, dispatch]);
    const handleTraceUserVisits = useCallback(() => {
        return () => {
            window.removeEventListener('beforeunload', marketplaceClosedTrack);
        };
    }, [marketplaceClosedTrack]);
    useEffect(() => {
        window.addEventListener('beforeunload', marketplaceClosedTrack);
        function fetchData() {
            setIsFetching(true);
            dispatch(getExtensionsList());
            setIsFetching(false);
        }
        fetchData();
        return handleTraceUserVisits();
    }, [dispatch, handleTraceUserVisits, marketplaceClosedTrack]);
    return (<div className='Extensions-list-page__container'>
      <RatingDialog extension={selectedExt} onSubmit={handleSubmitRating} onClose={handleDismissRating}/>
      <div className='Extensions-list-page__header'>
        <div>
          <div className='Extensions-list-page__heading'>
            <FormattedMessage id="account.extensions.new-title" defaultMessage="Telehealth Tools"/>
          </div>
          <div className='Extensions-list-page__title'>
             <FormattedMessage id="account.extensions.description" defaultMessage="Customize your doxy.me experience with these extensions"/>
          </div>
        </div>
      </div>
      <div className='Extensions-list-page__extensions-list'>
        {!isFetching && extensions.length > 0 ? (<ExtensionListPageThumbnails extensions={filterAvailableExtensions(extensions, user, institution)} user={user} institution={institution} nativeExtensionsList={nativeExtensionsList} isInstalled={false} handleExtensionClick={handleExtensionClick}/>) : (<NoResults show={!isFetching && extensions.length === 0}/>)}
      </div>

      {extensions.length > 0 &&
            <div className='Extensions-list-page__list-divider-wrapper'>
          <div className='Extensions-list-page__list-divider'/>
          <div className='Extensions-list-page__list-divider-text'>
            <FormattedMessage id="account.extensions.installed-tools-divider-text"/>
          </div>
          <div className='Extensions-list-page__list-divider'/>
        </div>}

      <div className='Extensions-list-page__extensions-list'>
        {!isFetching && extensions.length > 0 && (<ExtensionListPageThumbnails extensions={filterInstalledExtensions(extensions, user, institution).sort(sortByTitle)} user={user} institution={institution} nativeExtensionsList={nativeExtensionsList} isInstalled={true} handleExtensionClick={handleExtensionClick}/>)}
      </div>
    </div>);
};
